module.exports = __webpack_public_path__ + "static/media/lawn.2e60ec92.jpg";